import { render, staticRenderFns } from "./MatrixWeightTableColumn.vue?vue&type=template&id=6ac4f20e"
import script from "./MatrixWeightTableColumn.vue?vue&type=script&lang=js"
export * from "./MatrixWeightTableColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports